import "./Input.css";

function Input({type, id, placeholder, value, onChange, style}) {
    return (  
        <input className="form-input" type={type} id={id} value={value} placeholder={placeholder} onChange={onChange} style={style}/>
    );
}

export default Input;